export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEMOTBtc3AtUktTSi1IYQOBqACFYwAAhWIAAYVgYQaBQQG9Tw0BvVEJAr1TAgS9VgQRvVsGAL1tYQKBQwDATAAAwFJBFYGswE6BcoVBAQABAAEAAQAZAB8AAQABAAYAUwABAAEAAQABABkAIAABAAEABgBhAYOVAb4CUSCEn7o5BR4OCRE+ER4xPnMFIg4JEUYRHjFOOQ8cL0IlFyQ3QnEMh18BvgQAwQkAvgcAwRMAvgkAwRIBvgsAwRgBvg4AwRwBvhEAwR1hAYeAAb4U", "base64")


//////////////////
// WEBPACK FOOTER
// ./src/components/vue-pdf/src/buffer-loader.js!./node_modules/pdfjs-dist/cmaps/90msp-RKSJ-V.bcmap
// module id = dhGp
// module chunks = 0